<template>
    <div class="sm:p-6">
        <tw-card divide title="Our Top Referrers" class="transition duration-500 ease-in-out dark:text-white" height="dark:bg-gray-700 dark:sm:bg-gray-800">
            <div class="shadow overflow-y-auto border border-gray-300 dark:border-gray-900 transition duration-500 ease-in-out sm:rounded-lg sm:mt-4">
                <table class="border-collapse table-auto w-full divide-y divide-gray-200 table-auto" v-if="referrers.length">
                    <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                User
                            </th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Tokens
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Referred
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200">
                        <tr v-for="(referrer, referrerKey) in referrers" :key="referrerKey" :class="referrerKey % 2 === 0 ? 'bg-white transition duration-500 ease-in-out dark:bg-gray-600' : 'bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-800'" class="dark:hover:bg-opacity-80">
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm  text-left text-gray-900 transition duration-500 ease-in-out dark:text-white whitespace-nowrap">
                                    {{ referrer.username }}
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white text-left">
                                <div class="text-sm text-left font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    {{ referrer.referral_totals.tokens }}
                                </div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white whitespace-pre-wrap">{{ referrer.referral_totals.referrals }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    <alert type="info" class="mt-4">
                        <template #title>
                            No referrals Available!
                        </template>
                        <template #message>
                            You haven't referred any users yet.
                        </template>
                    </alert>
                </div>
            </div>
        </tw-card>
    </div>
</template>
<script>
import { ref } from 'vue'
import TwCard from '@/Global/Elements/TwCard'

export default {
    components: {
        TwCard,
    },

    props: {
        referrers: Object,
    },

    setup(props) {


        return {
            //
        }
    }
}

</script>
